<template>
    <div>
        <!-- Pending Cancellations -->
        <div class="row" v-if="pendingCancellation">
            <div class="col">
                <div class="sau-bx bx-pad text-center">
                    <p class="sau-font sm">A cancellation request is currently pending for this service</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pendingCancellation: false,
        }
    },
    created() {
        this.startApp();
    },
    methods: {
        startApp() {
            this.checkPendingCancellations().then(response => {
                if(response.data.status == 'success') {
                    this.pendingCancellation = response.data.pendingCancellation;
                }
            });
        }
    }
}
</script>
<style>
</style>